module.exports = __webpack_public_path__ + "static/media/calendar.22045692.svg";